var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9818 2.81827L14.6484 3.69289C16.4415 4.63384 17.338 5.10432 17.8358 5.94974C18.3337 6.79517 18.3337 7.84718 18.3337 9.95122V10.0487C18.3337 12.1527 18.3337 13.2048 17.8358 14.0502C17.338 14.8956 16.4415 15.3661 14.6484 16.307L12.9818 17.1817C11.5187 17.9494 10.7872 18.3333 10.0003 18.3333C9.21343 18.3333 8.48192 17.9494 7.0189 17.1817L5.35224 16.307C3.55918 15.3661 2.66265 14.8956 2.16482 14.0502C1.66699 13.2048 1.66699 12.1527 1.66699 10.0487V9.95122C1.66699 7.84718 1.66699 6.79517 2.16482 5.94974C2.66265 5.10432 3.55918 4.63384 5.35224 3.69289L7.0189 2.81826C8.48192 2.05051 9.21343 1.66663 10.0003 1.66663C10.7872 1.66663 11.5187 2.05051 12.9818 2.81827Z",
    stroke: "#1D1616",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.25L10 10M10 10L2.5 6.25M10 10V17.9167",
    stroke: "#1D1616",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.edc182d305f37d0d7fbda17c1ce60a92.svg";
export { ForwardRef as ReactComponent };